import { render, staticRenderFns } from "./EditarPerfil.vue?vue&type=template&id=3e15bb13"
import script from "./EditarPerfil.vue?vue&type=script&lang=js"
export * from "./EditarPerfil.vue?vue&type=script&lang=js"
import style0 from "./EditarPerfil.vue?vue&type=style&index=0&id=3e15bb13&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports